export default {
  "content": "<g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-1 0h16v16H-1z\"/><g stroke=\"#fff\" stroke-linejoin=\"round\"><path d=\"M10.233 1.939l2.828 2.828L3.87 13.96l-2.83-2.83z\"/><path d=\"M.5 14.5l.54-3.37 2.83 2.83zM13.414 1.585a2 2 0 010 2.828l-.353.354-2.828-2.829.353-.353a2 2 0 012.828 0z\"/></g></g>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "15",
    "height": "15",
    "viewBox": "0 0 15 15"
  }
};